// "Insérer au ¶" — an HONEST disabled ComingSoon affordance on agent messages
// (F-AGENT PR-B). It dispatches NOTHING: inserting the answer/citation at the
// Word caret is the ONLY Office.js part of F-AGENT, deferred to
// F-AGENT-INSERT (needs a `Word.run` ContentControl adapter + Word smoke +
// legal sign-off — W2/W3). Rather than fake a click that does nothing, the
// button is `disabled` and carries a `title` explaining it's coming. Mirrors
// the honest-placeholder posture of `plan/OutlineComingSoon`.
//
// §9 — logical RTL utilities only; all strings via `t('agent.insert.*')`.

import { useTranslation } from 'react-i18next'

export function InsertAffordance(): JSX.Element {
  const { t } = useTranslation()
  return (
    <button
      type="button"
      disabled
      data-testid="agent-insert-affordance"
      title={t('agent.insert.comingSoon')}
      className="inline-flex cursor-not-allowed items-center gap-1 rounded border border-ink/15 px-2 py-0.5 text-[10px] font-semibold text-ink/40"
    >
      {t('agent.insert.label')}
    </button>
  )
}
